
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/verify",
      function () {
        return require("private-next-pages/verify/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/verify"])
      });
    }
  